/* ==========================================================================
   NEUROCLAW — motion engine (scroll-reveal + stat counters + config type-in).
   One small file, IntersectionObserver-gated, reduced-motion + no-JS safe.

   Contracts (markup just adds attributes, no per-section JS):
     [data-nc-reveal]            → fade/slide in once on enter (+ optional
                                   [data-nc-reveal-delay="1..6"] to stagger)
     [data-nc-count="42"]        → number counts up from 0 → target on enter
                                   (keeps any trailing/leading non-digits, e.g.
                                   "4.8", "1–2", "100%"; integers animate)
     [data-nc-typed] [data-nc-line] → child lines reveal sequentially on enter

   Perf: observers disconnect after firing; nothing runs offscreen; the whole
   thing is deferred. CLS-safe: reveal only animates transform/opacity.
   ========================================================================== */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.documentElement;

  // Mark the document reveal-ready so the CSS hidden-state engages only when JS
  // is alive. (CSS shows everything if this class is absent.)
  root.classList.add('nc-reveal-ready');

  if (reduce || !('IntersectionObserver' in window)) {
    // Show everything immediately, in final state.
    document.querySelectorAll('[data-nc-reveal]').forEach(function (el) { el.classList.add('is-in'); });
    document.querySelectorAll('[data-nc-typed]').forEach(function (el) { el.classList.add('is-typing'); });
    // counters: just leave the authored text as-is.
    return;
  }

  // ---- 1. Scroll reveal ----------------------------------------------------
  var revealObserver = new IntersectionObserver(function (entries, obs) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('is-in');
        obs.unobserve(e.target);
      }
    });
  }, { threshold: 0, rootMargin: '0px 0px 15% 0px' });
  document.querySelectorAll('[data-nc-reveal]').forEach(function (el) { revealObserver.observe(el); });

  // Safety net: content must NEVER stay invisible. If the observer hasn't
  // revealed an element shortly after load (timing, element taller than the
  // viewport, any edge case), force it visible. The animation is an
  // enhancement, never a gate on whether content shows.
  setTimeout(function () {
    document.querySelectorAll('[data-nc-reveal]:not(.is-in)').forEach(function (el) { el.classList.add('is-in'); });
  }, 1000);

  // ---- 2. Stat counters ----------------------------------------------------
  function animateCount(el) {
    var raw = String(el.getAttribute('data-nc-count') || el.textContent).trim();
    var m = raw.match(/^(\D*)(\d[\d.,]*)(\D*)$/);
    if (!m) { return; } // non-numeric → leave as-is
    var pre = m[1], numStr = m[2], post = m[3];
    // integer-only animation (keep decimals/separators static if present)
    var isInt = /^\d+$/.test(numStr);
    if (!isInt) { return; }
    var target = parseInt(numStr, 10);
    if (target === 0) { el.textContent = pre + '0' + post; return; }
    var dur = 1100, start = null;
    function step(ts) {
      if (start === null) start = ts;
      var p = Math.min(1, (ts - start) / dur);
      // easeOutCubic
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = pre + Math.round(eased * target) + post;
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = pre + target + post;
    }
    requestAnimationFrame(step);
    // Guarantee the final value even if rAF stalls during a heavy load (the
    // count-up is an enhancement; the correct number is never optional).
    setTimeout(function () { el.textContent = pre + target + post; }, dur + 300);
  }
  var countObserver = new IntersectionObserver(function (entries, obs) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { animateCount(e.target); obs.unobserve(e.target); }
    });
  }, { threshold: 0.5 });
  document.querySelectorAll('[data-nc-count]').forEach(function (el) { countObserver.observe(el); });

  // ---- 3. Config type-in (line by line) ------------------------------------
  var typeObserver = new IntersectionObserver(function (entries, obs) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var host = e.target;
      var lines = host.querySelectorAll('[data-nc-line]');
      lines.forEach(function (line, i) {
        line.style.animationDelay = (i * 90 + 40) + 'ms';
      });
      host.classList.add('is-typing');
      obs.unobserve(host);
    });
  }, { threshold: 0.35 });
  document.querySelectorAll('[data-nc-typed]').forEach(function (el) { typeObserver.observe(el); });
})();
